import React from "react";

export default function Widget1vs1Advance({ hostProfile, guestProfile }) {
  return (
    <div className="widget-header-advance-container">
      <div className="widget-header-advance-space"></div>
      <div className="widget-header-advance widget-header-advance-right">
        <p>{hostProfile.winPercentage} %</p>
        <p>
          {hostProfile.wins} / {hostProfile.looses}
        </p>
        <p>
          {hostProfile.streak > 0
            ? `+${hostProfile.streak}`
            : hostProfile.streak}
        </p>
      </div>
      <div className="widget-header-advance widget-header-advance-left">
        <p>
          {guestProfile.streak > 0
            ? `+${guestProfile.streak}`
            : guestProfile.streak}
        </p>
        <p>
          {guestProfile.wins} / {guestProfile.looses}
        </p>
        <p>{guestProfile.winPercentage} %</p>
      </div>
      <div className="widget-header-advance-space"></div>
    </div>
  );
}
